import { useState } from 'react';
import { Link } from 'react-router-dom';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { type AccountResponse, AccountType } from '@shared/api';
import { AccountCardTile, AccountCardTileVcfc } from './card';
import { AccountPaymentTile, AccountPaymentTileVcfc } from './payment';

interface AccountTileSmallProps {
  className?: string;
  account: AccountResponse;
  subAccounts?: AccountResponse[];
}

export const AccountTileSmall = (props: AccountTileSmallProps) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);

  return (
    <>
      {props.account.type === AccountType.Payment && (
        <Link
          className={cn('transition-transform duration-200 hover:scale-[103%]', props.className)}
          to={RoutePaths.account.onNavigate(props.account.id)}
          onDragStart={(e) => (e.preventDefault(), setIsDragging(true))}
          onMouseUp={() => setTimeout(() => setIsDragging(false), 0)}
          onMouseLeave={() => setTimeout(() => setIsDragging(false), 0)}
          onClick={(e) => isDragging && e.preventDefault()}
        >
          {PaletteUtils.isInsigniaPalette && <AccountPaymentTile accounts account={props.account} subAccounts={props.subAccounts} />}
          {PaletteUtils.isVcfcPalette && <AccountPaymentTileVcfc accounts account={props.account} subAccounts={props.subAccounts} />}
        </Link>
      )}
      {props.account.type === AccountType.Card && (
        <Link
          className={cn('transition-transform duration-200 hover:scale-[103%]', props.className)}
          to={RoutePaths.account.onNavigate(props.account.id)}
          onDragStart={(e) => (e.preventDefault(), setIsDragging(true))}
          onMouseUp={() => setTimeout(() => setIsDragging(false), 0)}
          onMouseLeave={() => setTimeout(() => setIsDragging(false), 0)}
          onClick={(e) => isDragging && e.preventDefault()}
        >
          {PaletteUtils.isInsigniaPalette && <AccountCardTile account={props.account} />}
          {PaletteUtils.isVcfcPalette && <AccountCardTileVcfc account={props.account} />}
        </Link>
      )}
    </>
  );
};
